import { useEffect, useState } from "react";
import { chartColorPalettes } from "../lib/chartColors";

// useChartColors.ts
export function useChartColors(page: keyof typeof chartColorPalettes) {
  const [theme, setTheme] = useState<"light" | "dark" | null>(null);

  useEffect(() => {
    const getTheme = () =>
      document.documentElement.classList.contains("dark") ? "dark" : "light";

    const observer = new MutationObserver(() => {
      setTheme(getTheme());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    setTheme(getTheme()); // initial
    return () => observer.disconnect();
  }, []);

  if (!theme) return null;

  return chartColorPalettes[page][theme];
}
